export const hobbies = [
  {
    id: 8,
    img: "/images/art/forest.jpg",
    text: " Forest Vibes",
    medium: "Acrylics",
    price: "2.0",
    size: "20x20cm",
    category: "nature",
    desc: "This painting is inspired by a Youtube tutorial. I love nature and love bringing it into my home. Would you want to feel like you are in a forest in your own home too?",
  },
  {
    id: 3,
    img: "/images/art/beach.jpg",
    text: "Tropical Beach",
    medium: "Acrylics",
    price: "2.0",
    size: "20x20cm",
    category: "nature",
    desc: "This painting is inspired by a Youtube tutorial. The ocean always gives me a sense of calm. Do you want to bring a calmer and a tropical vibe to you own home? Then this painting is perfect for your decor",
  },
  {
    id: 2,
    img: "/images/art/hammock.jpg",
    text: "Hammock on the Sea",
    medium: "Acrylics",
    price: "2.0",
    size: "20x20cm",
    category: "nature",
    desc: " This painting is inpired by a Youtube tutorial. This paining is a beautiful way to bring a brilliant blue to your home as well as the ocean. It can make you feel the tropicals within your own space.",
  },
  {
    id: 4,
    img: "/images/art/river.png",
    text: "River",
    medium: "Digital",
    price: "2.0",
    size: "20x20cm",
    category: "nature",
    desc: "This painting is inspired by my own imagination. It is created on SketchUp, a painting app on my tablet. The beauty of painting digitally is that you can have more flexibility and chances of making mistakes. ",
  },
  {
    id: 5,
    img: "/images/art/actor2.PNG",
    text: "Turkish Actress",
    medium: "Prisma",
    price: "2.0",
    size: "20x20cm",
    category: "portraits",
    desc: "This painting is inspired by my own imagination. It is created on SketchUp, a painting app on my tablet. The beauty of painting digitally is that you can have more flexibility and chances of making mistakes. ",
  },
  {
    id: 6,
    img: "/images/art/balloon_LI.jpg",
    text: "Air Balloon",
    medium: "Digital",
    price: "2.0",
    size: "20x20cm",
    category: "objects",
    desc: "This painting is inspired by my own imagination. It is created on SketchUp, a painting app on my tablet. The beauty of painting digitally is that you can have more flexibility and chances of making mistakes. ",
  },
  {
    id: 7,
    img: "/images/art/bearzoom.jpg",
    text: "Bear (zoomed)",
    medium: "Oil Pastal",
    price: "2.0",
    size: "20x20cm",
    category: "animals",
    desc: "This painting is inspired by my own imagination. It is created on SketchUp, a painting app on my tablet. The beauty of painting digitally is that you can have more flexibility and chances of making mistakes. ",
  },
  {
    id: 1,
    img: "/images/art/cat.PNG",
    text: "Cat",
    medium: "Prisma",
    price: "2.0",
    size: "20x20cm",
    category: "animals",
    desc: "This is a painting of my own cat who drives me crazy by his cuteness everyday. He does all he can to get attention and, even in this painting, he can't help by do the same.",
  },
  {
    id: 9,
    img: "./images/art/dog.PNG",
    text: "Dog",
    medium: "Prisma",
    price: "2.0",
    size: "20x20cm",
    category: "animals",
    desc: "This painting is of my clients dog who I met a GM in Oshawa. She asked me to paint her dog a portrait. The original painting was already sold at around $90.",
  },
  {
    id: 10,
    img: "/images/art/elephant.jpg",
    text: "Elephant",
    medium: "Oil Pastal",
    price: "2.0",
    size: "20x20cm",
    category: "animals",
    desc: "This painting was inspired by rainbow colors and is one of the paintings that can bring alot of colors to your interior decor. This painting was done by me and my husband.",
  },
  {
    id: 12,
    img: "/images/art/horses.PNG",
    text: "Love Horses",
    medium: "Oil Pastal",
    price: "2.0",
    size: "20x20cm",
    category: "animals",
    desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sequi nemo voluptatibus voluptatem cum sed omnis libero illo. Aliquam, harum pariatur. Itaque accusamus alias molestias minima cumque. Dolores obcaecati rem reiciendis!  ",
  },
  {
    id: 13,
    img: "/images/art/parrot2.PNG",
    text: "Parrots",
    medium: "Prisma",
    price: "2.0",
    size: "20x20cm",
    category: "animals",
    desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sequi nemo voluptatibus voluptatem cum sed omnis libero illo. Aliquam, harum pariatur. Itaque accusamus alias molestias minima cumque. Dolores obcaecati rem reiciendis!  ",
  },
  {
    id: 14,
    img: "/images/art/panda.PNG",
    text: "Panda",
    medium: "Prisma",
    price: "2.0",
    category: "animals",
    size: "20x20cm",
    desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sequi nemo voluptatibus voluptatem cum sed omnis libero illo. Aliquam, harum pariatur. Itaque accusamus alias molestias minima cumque. Dolores obcaecati rem reiciendis!  ",
  },
  {
    id: 15,
    img: "/images/art/boy.PNG",
    text: "Young Actor",
    medium: "Graphite",
    price: "2.0",
    category: "portraits",
    size: "20x20cm",
    desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sequi nemo voluptatibus voluptatem cum sed omnis libero illo. Aliquam, harum pariatur. Itaque accusamus alias molestias minima cumque. Dolores obcaecati rem reiciendis!  ",
  },
  {
    id: 16,
    img: "/images/art/window.PNG",
    text: "Window",
    medium: "Acrylics",
    price: "2.0",
    category: "objects",
    size: "20x20cm",
    desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sequi nemo voluptatibus voluptatem cum sed omnis libero illo. Aliquam, harum pariatur. Itaque accusamus alias molestias minima cumque. Dolores obcaecati rem reiciendis!  ",
  },

  {
    id: 17,
    img: "/images/art/dreams.PNG",
    text: " Dreams",
    medium: "Oil Pastal",
    price: "5.0",
    category: "qoutes",
    size: "20x20cm",
    desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sequi nemo voluptatibus voluptatem cum sed omnis libero illo. Aliquam, harum pariatur. Itaque accusamus alias molestias minima cumque. Dolores obcaecati rem reiciendis!  ",
  },
  {
    id: 18,
    img: "/images/art/lillies.JPG",
    text: " Lillies",
    medium: "Oil Pastal",
    price: "4.0",
    category: "nature",
    size: "20x20cm",
    desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sequi nemo voluptatibus voluptatem cum sed omnis libero illo. Aliquam, harum pariatur. Itaque accusamus alias molestias minima cumque. Dolores obcaecati rem reiciendis!  ",
  },
  {
    id: 19,
    img: "/images/art/mermaid.jpg",
    text: "Mermaid",
    medium: "Oil Pastal",
    price: "3.0",
    category: "qoutes",
    size: "20x20cm",
    desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sequi nemo voluptatibus voluptatem cum sed omnis libero illo. Aliquam, harum pariatur. Itaque accusamus alias molestias minima cumque. Dolores obcaecati rem reiciendis!  ",
  },
];
